import { isSameDay, getMonth, isWeekend } from "date-fns";
import { checkHoliday } from "services/holidayService";

/**
 * Verifica se o parque está aberto em uma data específica.
 * @param {Date} dateObj - Objeto Date a ser verificado.
 * @param {Array} excecoes - Lista de objetos { date: Timestamp/Date, status: 'aberto'|'fechado' }.
 * @param {Array} mesesFechamento - Lista de índices de meses (0-11) que estão fechados.
 * @returns {boolean} - true se aberto, false se fechado.
 */
export const isParkOpen = (dateObj, excecoes = [], mesesFechamento = []) => {
  if (!dateObj) return false;

  // 1. Prioridade Alta: Exceções
  // Converte a data da exceção para comparação
  const excecaoEncontrada = excecoes.find((ex) => {
    // Normaliza para Date, caso venha do Firestore como Timestamp
    const exDate =
      ex.date && ex.date.toDate ? ex.date.toDate() : new Date(ex.date);
    return isSameDay(exDate, dateObj);
  });

  if (excecaoEncontrada) {
    return excecaoEncontrada.status === "aberto";
  }

  // 2. Fechamento Sazonal (Mês)
  const mesAtual = getMonth(dateObj); // 0 = Janeiro
  if (mesesFechamento.includes(mesAtual)) {
    return false;
  }

  // 3. Regra Padrão (Fim de Semana ou Feriado)
  // Aberto se for Sábado/Domingo OU Feriado
  if (isWeekend(dateObj)) {
    return true;
  }

  const holiday = checkHoliday(dateObj);
  if (holiday) {
    return true;
  }

  // Caso contrário (dias úteis sem feriado) -> Fechado
  return false;
};
